import React, {useState, useEffect, useRef} from 'react'

import BrassPanel from '../../../components/BrassPanel'

function MachineBigBtn({injectNX6, setPlayerInput, overheating}) {
    const [indicatorPosition, setIndicatorPosition] = useState(0)
    const tempIndicatorRef = useRef()
    
    function handleBigBtnClick() {
        if (!injectNX6) {
            setPlayerInput(prevInput => {
                return {
                    ...prevInput,
                    inject: true
                }
            })
        }
    }
    
    useEffect(() => {
        if (!overheating) {
            const randomTime = Math.floor((Math.random() * 750) + 200)
            let randomPos = Math.floor((Math.random() * 95) + 5)
            const timer = setTimeout(() => {
                randomPos === indicatorPosition && randomPos ++ 
                setIndicatorPosition(randomPos)
            }, [randomTime])

            return () => clearTimeout(timer)
        } else {
            setIndicatorPosition(0)
        }
    }, [indicatorPosition, overheating])
    
    useEffect(() => {
        tempIndicatorRef.current.style.transform = `translateX(-${indicatorPosition}%)`
    }, [indicatorPosition, overheating])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-bigButton'>
            <button 
                className='machine_bigButton'
                onClick={handleBigBtnClick}
            >
                Inject NX6
            </button>
            <div className='machine_display machine_display-bigButton'>
                <div className='bigButton_tempIndicator' ref={tempIndicatorRef}></div>
            </div>
        </BrassPanel>
    )
}

export default MachineBigBtn